import axios, { isAxiosError } from 'axios';
import { API_ROUTES } from '@/config/api-routes';
function parseBreakApiError(err) {
    if (!isAxiosError(err)) {
        return err instanceof Error ? err.message : 'Could not start break.';
    }
    const data = err.response?.data;
    if (Array.isArray(data?.fieldErrors) && data.fieldErrors.length > 0) {
        return data.fieldErrors
            .map((fe) => fe.message || fe.field || 'Validation error')
            .join(' · ');
    }
    if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message;
    }
    return err.message || 'Could not start break.';
}
/** Normalize UI input → `StartBreakRequestDTO` (OpenAPI: both fields required). */
export function buildStartBreakRequest(payload) {
    const breakReason = String(payload.breakReason ?? '').trim();
    const raw = payload.estimatedBreakDuration ??
        payload.estimatedMinutes;
    const n = typeof raw === 'number' ? raw : Number(raw);
    const estimatedBreakDuration = Number.isFinite(n) ? Math.trunc(n) : NaN;
    if (!breakReason) {
        throw new Error('Break reason is required.');
    }
    if (!Number.isFinite(estimatedBreakDuration) || estimatedBreakDuration < 1) {
        throw new Error('Estimated break duration is required (at least 1 minute).');
    }
    return { breakReason, estimatedBreakDuration };
}
/** POST `/api/breaks` — start agent break (`StartBreakRequestDTO`). */
export async function createBreakRequest(payload) {
    const body = buildStartBreakRequest(payload);
    try {
        const res = await axios.post(API_ROUTES.breaks, body);
        return res.data;
    }
    catch (err) {
        throw new Error(parseBreakApiError(err));
    }
}
/** GET `/api/breaks/active` — current open break, or `null` when none (HTTP 404). */
export async function fetchActiveBreak() {
    try {
        const res = await axios.get(API_ROUTES.breaksActive);
        return res.data;
    }
    catch (err) {
        if (isAxiosError(err) && err.response?.status === 404) {
            return null;
        }
        throw new Error(parseBreakApiError(err));
    }
}
/** PUT `/api/breaks/end` — end break / return to service. */
export async function endBreak() {
    await axios.put(API_ROUTES.breaksEnd);
}
/** PUT `/api/breaks/end-for-user` — supervisor force-ends another user's open break. */
export async function endBreakForUser(username) {
    const trimmed = String(username ?? '').trim();
    if (!trimmed) {
        throw new Error('Username is required to force return to service.');
    }
    try {
        await axios.put(API_ROUTES.breaksEndForUser, { username: trimmed });
    }
    catch (err) {
        throw new Error(parseBreakApiError(err));
    }
}
